import { render, staticRenderFns } from "./lp-collections.vue?vue&type=template&id=fcb929ce&scoped=true"
import script from "./lp-collections.vue?vue&type=script&lang=js"
export * from "./lp-collections.vue?vue&type=script&lang=js"
import style0 from "./lp-collections.vue?vue&type=style&index=0&id=fcb929ce&prod&scoped=true&lang=css"
import style1 from "./lp-collections.vue?vue&type=style&index=1&id=fcb929ce&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb929ce",
  null
  
)

export default component.exports